import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/About.css';

const About = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <div className="about-container">
      <nav className="about-nav">
        <div className="nav-content">
          <div className="logo" onClick={handleLogoClick}>
            Equation Live
          </div>
          <div className="nav-buttons">
            <button className="nav-button primary" onClick={() => navigate('/signin')}>
              Sign In
            </button>
          </div>
        </div>
      </nav>

      <main className="about-content">
        <div className="about-body">
          <section className="about-section">
            <h2>About</h2>
            <p>ChatGPT currently processes over 1 billion messages every day, but it only supports plain-text input limiting how users express complex ideas, especially in technical fields 
                like math, physics, and engineering. Equation Live is a browser extension that bridges this gap by enabling users to type and render mathematical equations directly within 
                their ChatGPT conversations. Whether you're a student, educator, researcher, or just someone who wants to communicate formulas more clearly, Equation Live makes your conversations with 
                ChatGPT more expressive, readable, and productive.</p>
          </section>

          <section className="about-section">
            <h2>More Coming Soon</h2>
            <p>Equation Live is a new project and is still in development. We are working on adding more features and improving the extension. </p>
          </section>

          <section className="about-section">
            <h2>Contact Us</h2>
            <p>Have questions, suggestions, or feedback? We'd love to hear from you:</p>
            <div className="contact-info">
              <p><strong>Support:</strong> <a href="/support">Contact Support</a></p>
              <p><strong>Email:</strong> support@equationlive.com</p>
            </div>
          </section>
        </div>
      </main>

      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Equation Live</h4>
            <p>Making LaTeX editing and rendering easy in ChatGPT</p>
          </div>
          <div className="footer-section">
            <ul>
              <li><a href="/support">Support</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/terms">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Equation Live. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default About; 